import {useRouter} from 'next/router';
import {useCallback} from 'react';

import {SEARCH_FILTERS} from '@/src/app/constants/search';
import useEmploymentTypes from '@/src/hooks/useEmploymentTypes';
import FilterRow from '@/src/Search/components/FilterRow';
import {useSearchFilters} from '@/src/Search/utils/useSearchFilters';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {CheckboxCommon, SimpleCollapse, Text} from '@/src/ui';

import css from '../styles/JobTypesCheckboxes.module.css';

const JobTypesCheckboxes = () => {
  const {employmentTypes} = useEmploymentTypes();
  const {query} = useRouter();
  // @ts-ignore
  const {setQueryFilters} = useSearchFilters();

  const onChangeHandler = useCallback(
    (event) => {
      const value = event.target.value;

      const selected =
        (!!query[SEARCH_FILTERS.WORK_TYPES] &&
          JSON.parse(query[SEARCH_FILTERS.WORK_TYPES] as string)) ||
        [];

      if (selected.includes(value)) {
        const newValue = selected.filter((jobType) => jobType !== value);
        setQueryFilters({
          [SEARCH_FILTERS.WORK_TYPES]: newValue.length
            ? JSON.stringify(newValue)
            : '',
        });
      } else {
        setQueryFilters({
          [SEARCH_FILTERS.WORK_TYPES]: JSON.stringify([
            ...selected,
            event.target.value,
          ]),
        });
      }
    },
    [query]
  );

  return (
    <SimpleCollapse
      defaultIsOpen
      headTitle={
        <Text
          fontSize={Text.FONT_SIZE.SIZE_16}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
        >
          <TextLocal id={'open-opportunities.participation'} />
        </Text>
      }
    >
      <FilterRow>
        {employmentTypes.map((type) => (
          <div className={css.checkboxes} key={type.value}>
            {/*@ts-ignore*/}
            <CheckboxCommon
              id={type.value}
              isSemibold
              value={type.value}
              name={type.value}
              label={type.label}
              checked={
                !!query[SEARCH_FILTERS.WORK_TYPES] &&
                JSON.parse(query[SEARCH_FILTERS.WORK_TYPES] as string).includes(
                  type.value
                )
              }
              onChange={onChangeHandler}
            />
          </div>
        ))}
      </FilterRow>
    </SimpleCollapse>
  );
};

export default JobTypesCheckboxes;
